<div class="p-4 overflow-auto max-h-[85vh]">

  <div class="flex justify-between -mt-4">
    <h2 class="text-xl font-semibold">Roles</h2>
    <p-button icon="pi pi-plus" label="Add Role" (click)="openAddModal()" class="mb-3"></p-button>
  </div>

  <p-table [value]="roles" [rows]="rows" [totalRecords]="totalRecords" [lazy]="true" (onLazyLoad)="loadRoles($event)"
    [loading]="loading">

    <ng-template pTemplate="header">
      <tr>
        <th>Role Name</th>
        <th>Created On</th>
        <th>Status</th>
        <th>Action</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-role>
      <tr>
        <td>{{ role.name }}</td>
        <td>{{ role.createdAt | date: 'dd/MM/yyyy' }}</td>
        <td>{{ role.status }}</td>
        <td>
          <div (click)="setRoleData(role)">
            <p-menu [tabindex]="undefined" #menu [model]="campusActionItem" [popup]="true" appendTo="body"></p-menu>
            <i (click)="menu.toggle($event)" class="pi pi-ellipsis-h action-button cursor-pointer"></i>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="loading">
      <tr>
        <td colspan="4" class="text-center">
          <p-progressSpinner></p-progressSpinner>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="4" class="no-data-record-found">
          <p>No records found</p>
        </td>
      </tr>
    </ng-template>
  </p-table>


</div>

<ng-container *ngIf="displayAddModal">
  <p-dialog [(visible)]="displayAddModal" [modal]="true" [style]="{width: '90rem'}" [closable]="false">
    <app-create-role (reload)="reload()" [orgId]="orgId" (close)="closeAddModal()"></app-create-role>
  </p-dialog>
</ng-container>



<ng-container *ngIf="showUpdateRole">
  <p-dialog [(visible)]="showUpdateRole" [modal]="true" [style]="{width: '90rem'}" [closable]="false">
    <app-create-role (reload)="reload()" [orgId]="orgId" [type]="'Update'" [roleDataToEdit]="roleDataToEdit"
      (close)="showUpdateRole = false"></app-create-role>
  </p-dialog>
</ng-container>

<ng-container *ngIf="showDeleteRole">
  <p-dialog [(visible)]="showDeleteRole" [modal]="true" [style]="{width: '40rem'}" [closable]="false">
    <app-delete-role [orgId]="orgId" (reload)="reload()" [roleDataToEdit]="roleDataToEdit"
      (close)="showDeleteRole = false"></app-delete-role>
  </p-dialog>
</ng-container>